import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Output, Input, EventEmitter } from '@angular/core';
import { AnalyticsService } from '../../services/api';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DatePipe } from '@angular/common';
import { TeachingSubjectComponent } from 'src/app/admin/contact-list/contact-edit/teaching-subject/teaching-subject.component';

@Component({
	selector: 'time-used-report',
	templateUrl: 'time-used-report.component.html',
	styleUrls: ['time-used-report.component.scss'],
	providers: [DatePipe]
})

export class TimeUsedReportComponent implements OnInit, OnChanges {
	@Input() deviceId:number = -1;
	@Input() schoolId:number = -1;
	@Input() projectId:number | undefined = -1;
	@Input() isout:boolean | undefined = false;
	@Input() viewsize: [number, number] = [1000, 500];
	@Input() outstartDate: Date = new Date();
	@Input() outendDate: Date = new Date();
	@Output() backEvent = new EventEmitter();
	dates: any[] = [];
	reportdata :any[] = [];
  nodata: boolean = true;
	// options
	legend: boolean = true;
	showLabels: boolean = true;
	animations: boolean = true;
	xAxis: boolean = false;
	yAxis: boolean = true;
	showYAxisLabel: boolean = true;
	showXAxisLabel: boolean = true;
	yAxisLabel: string = 'Time(min)';
	xAxisLabel: string = 'Dates';
	timeline: boolean = true;
	colorScheme = [{"name": "time(min)","value": "#4F94D3"}];
	currentDate : string = '';
	startDate: Date = new Date();
	endDate: Date = new Date();

	ngOnInit() {
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else if(this.projectId != -1){
			this.getProjectReports();
		}else {
			this.getDeviceReports();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.xAxis = !this.isout;
		if(changes.outstartDate){
			this.outstartDate = new Date(changes.outstartDate.currentValue);
			console.log(this.outstartDate);

			const today = new Date()
			let day = 86400000
			this.endDate = new Date(this.outstartDate.getTime() + (90 * day));
			if(!this.isout)
				this.startDate = new Date(today.getTime() - (365 * day));
			else{
				this.startDate = this.outstartDate;
				this.endDate = this.outendDate;
			}
				

			if(this.schoolId != -1){
				this.getSchoolReports()
			}else if(this.projectId != -1){
				this.getProjectReports();
			}else {
				this.getDeviceReports();
			}

	}
	}


	private getDateString(day:Date){
		if(day == null) day = new Date();
		return this.datePipe.transform(day, 'yyyy-MM-dd')!;
	}

	onSelectDate(){
    this.nodata = true;
    this.currentdata = [];
    this.reportdata = [];
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else if(this.projectId != -1){
			this.getProjectReports();
		}else {
			this.getDeviceReports();
		}
	}


	private getSchoolReports(){
		this.service.analyticsGetTimeUsedSchoolReportPost(this.schoolId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
      this.prepareData(data)
		},error => {
      // Handle the error here
    });
	}

	private getProjectReports(){
    this.nodata = true;
    this.currentdata = [];
    this.reportdata = [];
		this.service.analyticsGetTimeUsedProjectReportPost(this.projectId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
		},error => {
      // Handle the error here
    });
	}


	private getDeviceReports(){

		this.service.analyticsGetTimeUsedDeviceReportPost(this.deviceId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
		},error => {
      // Handle the error here
    });
	}

  currentdata:any[] = [];
	private prepareData(data : any[]){
    this.reportdata = [];
    this.currentdata = [];
    if(data.length <= 0){
      return;
    }
    this.nodata = false;
		this.getDates(this.startDate,this.endDate);
		this.dates.forEach(item=>{
			console.log(item);
			let daydata = {name:item,value:0};
			daydata.value = this.dateExists(data, daydata.name!);
			this.currentdata.push(daydata);
		})

		this.reportdata =  [{
			name: 'time(min)',
			series: this.currentdata
		}];
	}

	dateExists(data:any[], date:string) {
		let newDate = new Date();
		let split = date.split('/');
		newDate.setDate(Number(split[0]));
		newDate.setMonth(Number(split[1]));
		newDate.setFullYear(Number(split[2]));
		let current = this.datePipe.transform(newDate, 'dd/MM/yyyy');
		for(let i=0;i<data.length;i++){
			let currentdate = new Date();
			split = data[i].day.split('/');
			currentdate.setDate(Number(split[1]));
			currentdate.setMonth(Number(split[0]));
			currentdate.setFullYear(Number(split[2]));
			let idate = this.datePipe.transform(currentdate, 'dd/MM/yyyy');

		  	if(idate == current) {
				let value: number =  Number((Number(data[i].timeUsed)/1000)/60);
				value = Math.round(value);
				return value;
			  }
		}
		return 0;
	  }


	navigateBack(){
		this.backEvent.next(null);
	}

	private addDays(currentDate:any) {
		let date = new Date(currentDate);
		date.setDate(date.getDate() + 1);
		return date;
	}

	getDates(startDate: Date, endDate: Date) {
		this.dates = [];
		let currentDate: Date = startDate;
		while (currentDate <= endDate) {
			let date = this.datePipe.transform(currentDate, 'dd/MM/yyyy');
			this.dates.push(date);
			currentDate = this.addDays(currentDate);
		}

		return this.dates;
	}

	constructor(private service: AnalyticsService, private datePipe: DatePipe) {
		const today = new Date()
		let day = 86400000
		this.startDate = new Date(today.getTime() - (3 * 30 * day));
	}

	  getData(day: string, time: number){
		  time = (time/1000)/60;
		  return  {name:day,value:time};
	  }

}
